import { render } from "./videoWorkDetail.vue?vue&type=template&id=c193f972&scoped=true"
import script from "./videoWorkDetail.vue?vue&type=script&lang=js"
export * from "./videoWorkDetail.vue?vue&type=script&lang=js"

import "./videoWorkDetail.vue?vue&type=style&index=0&id=c193f972&lang=less&scoped=true"
import "./videoWorkDetail.vue?vue&type=style&index=1&id=c193f972&lang=css"

import exportComponent from "D:\\benq\\dev-front\\design-competition\\2021\\design-competition-web-pc\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c193f972"]])

export default __exports__